import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Instrument } from './instrument.model';
import { InstrumentsStore } from './instruments.store';
import { AppConfigQuery } from '../../../core/state/app-config/app-config.query';
@Injectable({ providedIn: 'root' })
export class InstrumentsService {
    constructor(
        private instrumentsStore: InstrumentsStore,
        private http: HttpClient,
        private config: AppConfigQuery
    ) {}

    getById(id) {
        return this.http
            .get<Instrument>(
                `${this.config.get().gatewayBaseUrl}/instruments/single/${id}`
            )
            .pipe(tap((entity) => this.instrumentsStore.update(id, entity)));
    }

    get() {
        return this.http
            .get<Instrument[]>(`${this.config.get().gatewayBaseUrl}/instruments`)
            .pipe(
                tap((entities) => {
                    this.instrumentsStore.set(entities);
                })
            );
    }

    add(instrument: Instrument) {
        this.instrumentsStore.add(instrument);
    }

    update(id, instrument: Partial<Instrument>) {
        this.instrumentsStore.update(id, instrument);
    }

    remove(id: number) {
        this.instrumentsStore.remove(id);
    }

    setActive(instrumentId: number) {
        this.instrumentsStore.setActive(instrumentId);
    }
}
